import { tv } from "@ui/lib/tv";
import { Children, type ReactNode } from "react";

const avatarStack = tv({
  slots: {
    // Subtle group lift; each avatar carries its own white ring via its className.
    root: "flex items-center drop-shadow-[0px_3px_5px_rgba(0,0,0,0.1)]",
    // ~50% overlap for size-52 avatars (matches the Figma pin).
    item: "-ml-[26px] first:ml-0",
  },
});

export interface AvatarStackProps {
  children: ReactNode;
  className?: string;
}

export function AvatarStack({ children, className }: AvatarStackProps) {
  const styles = avatarStack();
  const count = Children.count(children);

  return (
    <div className={styles.root({ className })}>
      {Children.map(children, (child, index) => (
        <div className={styles.item()} style={{ zIndex: count - index }}>
          {child}
        </div>
      ))}
    </div>
  );
}
